import React, { Component } from 'react'
import './style.css'
import Event1 from '../../assets/image/event1.jpg'
import NoImage from '../../assets/image/no_image.png'
import moment from 'moment'
import {Button} from '@material-ui/core'
export default class grid3 extends Component {
    render() {
        let {data}=this.props
        return (
            <div className='grid3-container'>
                {data.map((data,i)=>(
                    <div key={i}  style={{display:'flex',flexDirection:'column'}} onClick={()=>window.location.assign(`https://content.gmlperformance.com/event/${data.webEvent.slug}`)}>
                    <div className='grid3-box-img-overlay'>
                        <img src={data.thumbnailURL!==null?data.thumbnailURL:NoImage} className='grid3-box-img'/>
                    </div>
                    <div className='grid3-box-content'>
                        <div style={{display:'flex',justifyContent:'space-between'}}>
                            {data.webEvent.fromDate===data.webEvent.toDate?
                            <h3>{moment(data.webEvent.fromDate).format('D MMM YYYY')}</h3>
                            :
                            <h3>{moment(data.webEvent.fromDate).format('D MMM')} - {moment(data.webEvent.toDate).format('D MMM YYYY')}</h3>
                            }
                            {data.webEvent.startTime!==""&&<h3 >{data.webEvent.startTime} - {data.webEvent.endTime} WIB</h3>}
                        </div>
                        <br/>
                        <p>{data.webEvent.intro}</p>
                        <div className='grid2-footer'>
                        <Button style={{textTransform:'none',fontWeight:'bold',padding:0}} color="primary" onClick={()=>window.location.assign(`https://content.gmlperformance.com/event/${data.webEvent.slug}`)}>Read more </Button>
                        </div>
                    </div>
                </div>
                ))}
                
            </div>
        )
    }
}
